export const currencyIntegerToString = (value: number) => {
  const str = `${value}`
  const commaPos = str.length - 2
  return `R$ ${str.substring(0, commaPos)},${str.substring(commaPos)}`
}

export const currencyStringToString = (value: string) => {
  const str = `${+value}`.match(/\d+/g)?.join('')?.padEnd(4, '0')
  if (!str) return 'ERROR'
  const commaPos = str.length - 2
  return `R$ ${str.substring(0, commaPos)},${str.substring(commaPos)}`
}
